import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as GeoLocationSelectors from './geolocation.selectors'
import { combineLatest, map, Observable } from 'rxjs'
import { globalCountryCodes } from './geolocation.models'

@Injectable({
  providedIn: 'root',
})
export class GeolocationFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(GeoLocationSelectors.selectGeolocationLoaded))
  geolocation$ = this.store.pipe(select(GeoLocationSelectors.selectGeolocation))

  isSaasLocation$: Observable<boolean | null> = combineLatest([this.geolocation$, this.loaded$]).pipe(
    map(([geoLocation, loaded]) => {
      if (!loaded) return null

      // Default to true (SaaS) on API failure or missing country code (e.g. ad blockers blocking ipdata.co).
      // This prevents hiding the registration link; non-SaaS users bypassing this are still validated by the API.
      if (!geoLocation?.country_code) return true

      return globalCountryCodes.includes(geoLocation.country_code || '')
    }),
  )

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
